
export type TransactionType = 'expense' | 'income' | 'debt' | 'receivable';
export type FinancialNoteType = 'profit' | 'loss' | 'debt' | 'receivable';

export enum Category {
  FOOD = 'Food',
  TRAVEL = 'Travel',
  SHOPPING = 'Shopping',
  BILLS = 'Bills',
  HEALTH = 'Health',
  EDUCATION = 'Education',
  ENTERTAINMENT = 'Entertainment',
  OTHERS = 'Others',
  SALARY = 'Salary',
  INVESTMENT = 'Investment'
}

export interface Transaction {
  id: string;
  user_id: string;
  household_id?: string;
  payer_guest_id?: string;
  amount: number;
  date: string;
  type: TransactionType;
  category: Category;
  note?: string;
  receipt_url?: string;
  is_recurring?: boolean;
  is_settled?: boolean;
  created_at: string;
  user_email?: string;
}

export interface MonthlySummary {
  income: number;
  expense: number;
  debt: number;
  receivable: number;
}

export interface UserProfile {
  id: string;
  display_name?: string;
  email_reports_enabled: boolean;
  save_receipts: boolean;
  pin?: string;
  pdf_pin?: string; // Master key for PDF encryption
  updated_at: string;
}

export interface Household {
  id: string;
  name: string;
  invite_code: string;
  created_by: string;
  created_at: string;
}

export interface HouseholdMember {
  household_id: string;
  user_id: string;
  joined_at: string;
}

export interface GroupGuest {
  id: string;
  household_id: string;
  name: string;
  created_at: string;
}

export interface GroupMemberExclusion {
  id: string;
  household_id: string;
  excluded_id: string;
  month: string;
  created_at: string;
}

export interface FinancialNote {
  id: string;
  user_id: string;
  title: string;
  content?: string;
  amount: number;
  type: FinancialNoteType;
  created_at: string;
  updated_at?: string;
}
